import axios from 'axios'

export const user = {
  namespaced: true,
  state: () => ({
    detail: {},
    status: {},
    cards: []
  }),

  mutations: {
    setDetail(state, detail) {
      state.detail = detail
    },
    setStatus(state, status) {
      state.status = status
    },
    setCards(state, data) {
      state.cards = data.cards
    },
    clean(state) {
      state.detail = {}
      state.status = {}
      $cookies.remove('wegow.auth_token')
      $cookies.remove('wegow.access_token')
      $cookies.remove('wegow.refresh_token')
    }
  },

  actions: {
    async detail({ commit }) {
      await axios
        .get(`/users/me/`)
        .then(res => {
          commit('setDetail', res.data)
        })
        .catch(res => {
          if (res.status !== 401) {
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    async cards({ commit }) {
      await axios
        .get(`/cards/`)
        .then(res => {
          commit('setCards', res.data)
        })
        .catch(res => {
          if (res.status !== 401) {
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    async update({ commit }, payload) {
      await axios
        .patch(`/users/${payload.user}/`, payload.data)
        .then(res => {
          commit('setDetail', res.data)
        })
        .catch(res => {
          if (res.status !== 401) {
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    async status({ commit }, payload) {
      await axios
        .get(`/user-status/`)
        .then(res => {
          commit('setStatus', res.data)
        })
        .catch(res => {
          if (res.status !== 401) {
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    async clean({ commit }) {
      await axios
        .post(`/auth/logout/`)
        .then(() => {
          commit('clean')
        })
        .catch(res => {
          if (res.status !== 401) {
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    }
  }
}
